import { getCurrencies } from 'store/reducers/currencies'
import { useAppSelector } from 'store/hooks'
import { ICurrency } from 'store/fetchers/currencies'

export interface IUseCurrency {
  code: string
  network: string
}

export function useCurrency(currency: IUseCurrency, currencies?: ICurrency[]): ICurrency {
  let currenciesList = currencies

  if (!currenciesList) {
    currenciesList = useAppSelector(getCurrencies)
  }
  if (!currency?.code || !currency?.network) {
    return null
  }

  if (currency?.code?.toLowerCase() === 'usdttrc20') {
    return currenciesList?.find((c) => c?.code?.toLowerCase() === 'usdt' && c?.network?.toLowerCase() === 'trx')
  }

  return currenciesList?.find(
    (c) =>
      currency?.code?.toLowerCase() === c?.code?.toLowerCase() &&
      currency?.network?.toLowerCase() === c?.network?.toLowerCase(),
  )
}

export function useMultipleCurrency(params: Array<IUseCurrency>, currencies?: ICurrency[]): ICurrency[] {
  let currenciesList = currencies
  if (!currenciesList) {
    currenciesList = useAppSelector(getCurrencies)
  }

  return params.map((config) => useCurrency(config, currenciesList))
}
